import { cn } from "@/lib/utils";
import React, { useState } from "react";
import { Button } from "../ui/button";
import show from "../../assets/eye-alt.svg";
import hide from "../../assets/eye-slash.svg";
function InputPassword({
  className,
  children,
  ...otherProps
}: Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="relative">
      <input
        type={`${showPassword ? "text" : "password"}`}
        className={cn(
          "py-1.5 px-3 rounded-lg border border-gray-100 w-full h-[46px] focus:outline-primary-400",
          className
        )}
        {...otherProps}
      >
        {children}
      </input>
      {!otherProps.disabled && <Button
        variant={"ghost"}
        size={"icon"}
        type="button"
        className="absolute top-1/2 right-1 -translate-y-1/2 mt-[1px]"
        onClick={() => setShowPassword((old) => !old)}
      >
        <img src={showPassword ? show : hide} width={16} height={16} />
      </Button>}
    </div>
  );
}

export default InputPassword;
